import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ProductSearchPage, ProductSearchService } from '@spartacus/core';
import { ProductScrollComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ICON_TYPE } from '../../../../../../../custom/icons/icon.model';
import { CustomProductListComponentService } from '../custom-product-list-component.service';

@Component({
  selector: 'app-custom-product-scroll',
  templateUrl: './custom-product-scroll.component.html',
  standalone: false
})
export class CustomProductScrollComponent extends ProductScrollComponent {
  iconType = ICON_TYPE;
  isLoaded = false;
  //protected isLoading$ = new BehaviorSubject<boolean>(false);
  private oldInputModel: ProductSearchPage;

  @Input('model')
  set setModel(inputModel: ProductSearchPage) {
    if (this.oldInputModel !== inputModel && !this.isLoaded) {
      this.oldInputModel = inputModel;
      this.isLoaded = true;
      this.customInfiniteScrollOperations(inputModel);
    } else {
      this.isLoaded = false;
    }
  }

  constructor(
    protected productSearchService: ProductSearchService,
    private productListComponentsService: CustomProductListComponentService,
    private refs: ChangeDetectorRef
  ) {
    super(productListComponentsService, refs);
  }

  searchResults$: Observable<ProductSearchPage> = this.productSearchService
    .getResults()
    .pipe(filter((searchResult) => Object.keys(searchResult).length > 0));

  loadNextPage(pageNumber: number): void {
    this.isMaxProducts = false;
    this.scrollPage(pageNumber);
  }

  private customInfiniteScrollOperations(inputModel: ProductSearchPage): void {
    if (this.appendProducts) {
      this.model = {
        ...inputModel,
        products: this.model.products?.concat(inputModel.products ?? []),
      };
    } else {
      this.model = inputModel;
      this.maxProducts = this.productLimit;
      // this.isLoading$.next(true);
      // setTimeout(() => {
      //   this.isLoading$.next(false);
      // }, 2000);
    }
    this.customSetConditions();
    this.refs.markForCheck();
    // this.isLoaded = true;
    // setTimeout(() => {
    //   this.isLoaded = false;
    // }, 1000);
  }

  private customSetConditions(): void {
    this.isEmpty = !this.model.products || this.model.products.length === 0;

    this.isLastPage =
      this.model.pagination?.currentPage ===
      (this.model.pagination?.totalPages ?? 0) - 1;

    if (this.model.products) {
      this.isMaxProducts =
        this.productLimit !== undefined &&
        this.productLimit !== 0 &&
        this.model.products.length >= (this.maxProducts ?? 0);

      //Add the productLimit to the current number of products to determine the next max number of products
      if (this.isMaxProducts) {
        this.maxProducts =
          this.model.products.length + (this.productLimit ?? 0);
      }
    }

    //Only change viewMode once the new model is set
    //This prevents flickering issues
    if (this.viewMode !== this.inputViewMode) {
      this.viewMode = this.inputViewMode;
    }

    this.resetList = false;
    this.appendProducts = false;
  }
}
